var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowLeft = function SvgArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.245 7H15a1 1 0 1 1 0 2H3.25l2.5 2.295a1 1 0 0 1 0 1.41 1 1 0 0 1-1.435 0L.445 9.06a1.5 1.5 0 0 1 0-2.12l3.85-3.65a1.025 1.025 0 0 1 1.435 0 1 1 0 0 1 0 1.415L3.245 7Z"
  })));
};
export default SvgArrowLeft;